const AUTH_KEY = "application-form";

export const getAuthToken = () => {
  try {
    const token = window.localStorage.getItem(AUTH_KEY);

    return token;
  } catch (error) {
    console.error(error);
    return null;
  }
};

export const setAuthToken = (token) => {
  try {
    window.localStorage.setItem(AUTH_KEY, token);
  } catch (error) {
    console.error(error);
  }
};
